<template>
    <div class="question">
        <div class="form-label">
            <label class="text" :for="item.data.id">{{ item.data.question }}</label>
            <span v-if="item.data.question && item.data.mandatory" class="mandatory">*</span>
        </div>

        <label class="mandatory_warning" style="display: none">{{ item.data.mandatory_warning }}</label>
        <label class="customerrormessage" style="display: none">{{ item.data.customerrormessage }}</label>

        <div v-if="item.data.description && item.data.description !== ''" class="form-text">
            <p>{{ item.data.description }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Question',
    props: {
        item: {
            type: Object
        }
    },
};
</script>